import React, { useContext, useEffect, useState } from "react";
import Context from "../context";
import RadioAnswer from "./types/RadioAnswer";
import CheckboxAnswer from "./types/CheckboxAnswer";
import LongAnswer from "./types/LongAnswer";
import AssotiationAnswer from "./types/AssotiationAnswer";
import ShortAnswer from "./types/ShortAnswer";
import OrderAnswer from "./types/OrderAnswer";
import SpaceInText from "./types/SpaceInText";
import WithExplanation from "./types/WithExplanation";
import TransferAnswer from "./types/TransferAnswer";
import TableAnswers from "./types/TableAnswers";
import NumbersAnswer from "./types/NumbersAnswer";
// types 1 - radio,
//  2 - cheackbox
// 3 - long
// 4 - short
// 5 - Assotiation
// 6 - Space in text
// 7 - Последовательность

export default function Answers({type, data, id, writeAnswers, isPassed}) {
  const {answers, changeIsRightAnswers} = useContext(Context)
  const [answerss, setAnswers] = React.useState({})
  const [st,setSt]=useState([]);

  let tipsAnswers = [];
  
  useEffect(() => {
    const response = {
      [id]: answerss,
    }
    writeAnswers(response)
  }, [answerss])

  const SpaceInTextChangeHandler = e =>{
    let copy = Object.assign([], st);
    copy[e.target.name]=e.target.value;
    setAnswers({...answerss,'value':copy});
    setSt(copy);
  };


  function changeCheckbox(e) {
    setAnswers(answers => {
      return {
        ...answers,
        [e.target.getAttribute('answername')]:e.target.checked,
      }
    })
  }

  function changeRadioValue(e) {
    setAnswers(answers => {
      return {
        [e.target.getAttribute('answername')]:e.target.checked,
      }
    })
  }

  function changeWriteAnswer(e) {
    setAnswers(answers => {
      return {
        'value':e.target.value,
      }
    })
  }

  function changeAssotiationsAnswer(e) {
    setAnswers(answers => {
      return {
        ...answers,
        [e.target.getAttribute('answername')]:e.target.value//При выборе селекта нет тру фолс ??????
      }
    })
  }

  function changeOrderAnswer(actions) {
    setAnswers(answer => {
      return {
        'value': actions,
      }
    })
  }
  function changeWithExplanation(actions) {
    setAnswers(actions)
  }
  const TransferChangeHandler = actions =>{
    setAnswers(actions)
  };
  const TableChangeHandler = actions =>{
    setAnswers(actions)
  };
  const changeNumbersAnswer = actions =>{
    setAnswers(actions)
  };

  if(type === 1) {
    tipsAnswers = data.map((answer,i) => {
    return <RadioAnswer key={`key1${answer.name}`+i} data={answer} name={id} changeRadioValue={changeRadioValue} isPassed={isPassed} userAnswers={answers[id]}/>
  })
  }

  if(type === 2) {
    return <CheckboxAnswer data={data} changeHandler={changeCheckbox} isPassed={isPassed} userAnswers={answers[id]}/>
  }

  if(type === 3) {
    return <LongAnswer changeWriteAnswer={changeWriteAnswer} isPassed={isPassed}/>
  }

  if(type === 4) {
    return <ShortAnswer name={id} changeWriteAnswer={changeWriteAnswer} data={data} isPassed={isPassed} userAnswers={answers[id]}/>
  }

  if(type === 5) {
    return <AssotiationAnswer changeAssotiationsAnswer={changeAssotiationsAnswer} data={data} isPassed={isPassed} userAnswers={answers[id]}/>
  }

  if(type === 6) {
    return <SpaceInText data={data} changeHandler={SpaceInTextChangeHandler} isPassed={isPassed}/>
  }

  if(type === 7) {
    return <OrderAnswer data={data} changeOrderAnswer={changeOrderAnswer} userAnswers={answers[id]} isPassed = {isPassed}/>
  }
  if(type===8){
    return  <WithExplanation data={data} changeWriteAnswer={changeWithExplanation}  isPassed = {isPassed}/>
  }
  if(type === 9) {
    return <TransferAnswer data={data} changeHandler={TransferChangeHandler} isPassed={isPassed}/>
  }
  if(type === 10) {
    return <TableAnswers data={data} changeHandler={TableChangeHandler} isPassed={isPassed}/>
  }
  if(type===11){
    return <NumbersAnswer data={data} changeWriteAnswer={changeNumbersAnswer} isPassed={isPassed}/>
  }
  return (
    <div className="test-answers">
      {tipsAnswers}
    </div>
  )
}
